import { timeline } from '@/mocks/home';

const phaseStyle: Record<string, string> = {
  发酵: 'bg-primary-500 text-background-50',
  回应: 'bg-accent-500 text-background-50',
  核实: 'bg-secondary-500 text-background-50',
  围观: 'bg-background-300 text-foreground-800',
  待核实: 'bg-accent-100 text-accent-900',
  归档: 'bg-secondary-100 text-secondary-900',
};

export default function TimelineSection() {
  return (
    <section id="timeline" className="bg-background-100/60 border-b border-background-200">
      <div className="mx-auto max-w-[1240px] px-4 md:px-8 py-8 md:py-12">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-4 mb-6 md:mb-8">
          <div>
            <h2 className="font-heading text-xl md:text-2xl font-black text-foreground-950">
              吃瓜时间线
            </h2>
            <p className="mt-1.5 text-sm text-foreground-600">
              把散落的动态按发生顺序排好，哪些先发生、哪些后回应，一眼看清。
            </p>
          </div>
          <button
            type="button"
            className="self-start md:self-auto inline-flex items-center gap-2 h-9 px-4 rounded-md border border-background-300 bg-background-50 text-xs text-foreground-800 whitespace-nowrap cursor-pointer hover:border-foreground-400 transition-colors"
          >
            <i className="ri-filter-3-line" />
            只看已核实节点
          </button>
        </div>

        <ol className="relative border-l border-background-300 ml-2 md:ml-3">
          {timeline.map((node) => (
            <li key={`${node.date}-${node.title}`} className="relative pl-6 md:pl-8 pb-6 last:pb-0">
              <span className="absolute -left-[5px] top-1.5 w-2.5 h-2.5 rounded-full bg-primary-500 border-2 border-background-100" />
              <div className="rounded-lg border border-background-200 bg-background-50 p-4">
                <div className="flex items-center gap-2 flex-wrap mb-2">
                  <span className="font-heading text-xs font-bold text-foreground-500">{node.date}</span>
                  <span className={`text-[11px] font-medium px-2 py-0.5 rounded-full ${phaseStyle[node.phase] ?? 'bg-background-200 text-foreground-800'}`}>
                    {node.phase}
                  </span>
                </div>
                <h3 className="text-sm font-semibold text-foreground-950">{node.title}</h3>
                <p className="mt-1.5 text-xs text-foreground-600 leading-relaxed">{node.desc}</p>
              </div>
            </li>
          ))}
        </ol>
      </div>
    </section>
  );
}